import { computed, inject, type ComputedRef, type InjectionKey } from 'vue'
import type { WebsiteLink, WebsiteNavigation } from './types'

export interface WebsiteNavigationContext {
  navigations: ComputedRef<Map<string, WebsiteNavigation>>
}

export const websiteNavigationContextKey: InjectionKey<WebsiteNavigationContext> = Symbol('website-navigation-context')

export function useWebsiteNavigation(
  navigationId: () => string | undefined,
  legacyLinks: () => WebsiteLink[] | undefined,
): ComputedRef<WebsiteNavigation> {
  const context = inject(websiteNavigationContextKey)

  return computed(() => {
    const selected = navigationId()

    if (selected && context?.navigations.value.has(selected)) {
      return context.navigations.value.get(selected)!
    }

    return {
      id: selected ?? 'legacy-navigation',
      name: 'Main navigation',
      handle: 'main',
      purpose: 'primary',
      maxDepth: 1,
      items: (legacyLinks() ?? []).map((link, index) => ({
        id: `legacy-navigation-${index}`,
        label: link.label,
        kind: 'link',
        destination: link.destination,
        children: [],
      })),
    }
  })
}
